/* 🤖 this file was generated by svg-to-ts */
export const iconLogin: {
    name: 'login';
    data: string;
} = {
    name: 'login',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill="#000" fill-rule="evenodd" d="M10.886.539c5.714 0 10.347 4.632 10.347 10.347S16.6 21.233 10.886 21.233C5.17 21.233.539 16.6.539 10.886.54 5.17 5.172.539 10.886.539m.022 11.883h-.044.022a6.013 6.013 0 0 0-5.98 5.385 9.1 9.1 0 0 0 5.98 2.226 9.1 9.1 0 0 0 5.98-2.226 6.013 6.013 0 0 0-5.958-5.385m-.022-10.683A9.147 9.147 0 0 0 3.87 16.755a7.22 7.22 0 0 1 4.558-5.103 4.307 4.307 0 1 1 4.915 0 7.22 7.22 0 0 1 4.56 5.103A9.147 9.147 0 0 0 10.885 1.74m.022 9.483a3.107 3.107 0 1 0-.022 0h-.022Z"/></svg>`
};
